export default function () {
    return {
        perfectScroll: null,
    };
}
